<template>
  <v-app>
    <!-- <v-app-bar app dark color="primary" clipped-left>
      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
      <v-toolbar-title>
        <v-btn text to="/" class="text-none title ml-0 px-0">
          {{ brand }}
        </v-btn>
      </v-toolbar-title>
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="setAdmin()">
            <v-list-item-title>Admin</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setReviewer()">
            <v-list-item-title>Reviewer</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setWriter()">
            <v-list-item-title>Writer</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar> -->
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list>
        <MenuItem text="Beranda" route="/" icon="mdi-home" />
        <v-subheader v-if="!isAdmin">FORM</v-subheader>
        <div v-if="isAdmin">
          <MenuItem
            v-for="item in adminMenus"
            :key="item.text"
            :text="item.text"
            :route="item.route"
            :icon="item.icon"
          />
        </div>
        <div v-else>
          <MenuGroup
            v-for="item in menus"
            :key="item.nomor"
            :nomor="item.nomor"
            :text="item.text"
            :submenu="item.submenu"
          />
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view />
    </v-content>
    <v-dialog v-model="dialog" persistent width="400">
      <v-card>
        <v-card-title class="subtitle-2">
          Halaman tidak diijinkan
        </v-card-title>
        <v-card-text>
          Anda tidak diijinkan untuk mengakses halaman ini. Silahkan hubungi
          Administrator untuk keterangan lebih lanjut
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text class="primary text-none" @click="dialog = false">
            Oke
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import MenuGroup from "@/components/Menu/MenuGroup";
import MenuItem from "@/components/Menu/MenuItem";
import services from "@/services/local/hak";
export default {
  name: "app",
  components: { MenuGroup, MenuItem },
  data() {
    return {
      brand: process.env.VUE_APP_NAME,
      drawer: null,
      dialog: false,
      login: false,
      adminMenus: [
        {
          text: "Rekap",
          route: "/admin/rekap",
          icon: "mdi-file-export"
        },
        {
          text: "Kriteria",
          route: "/admin/kriteria",
          icon: "mdi-pencil"
        },
        {
          text: "Sub Kriteria",
          route: "/admin/sub-kriteria",
          icon: "mdi-pencil"
        }
      ]
    };
  },
  created() {
    const hak = services.getHak();
    if (hak) {
      this.$store.dispatch("setHak", parseInt(hak));
    } else {
      this.$router.push("/not-allowed");
      this.dialog = true;
      this.drawer = false;
    }
  },
  computed: {
    menus() {
      return this.$store.getters.menus;
    },
    isAuth() {
      return this.$store.getters.isAuth;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  methods: {
    setAdmin() {
      services.setHak(parseInt(process.env.VUE_APP_HAK_ADMIN));
      this.$store.dispatch("setHak", parseInt(process.env.VUE_APP_HAK_ADMIN));
    },
    setReviewer() {
      services.setHak(parseInt(process.env.VUE_APP_HAK_REVIEWER));
      this.$store.dispatch(
        "setHak",
        parseInt(process.env.VUE_APP_HAK_REVIEWER)
      );
    },
    setWriter() {
      services.setHak(parseInt(process.env.VUE_APP_HAK_WRITER));
      this.$store.dispatch("setHak", parseInt(process.env.VUE_APP_HAK_WRITER));
    }
  }
};
</script>
<style scoped>
.theme--dark.v-btn--active:hover::before,
.theme--dark.v-btn--active::before {
  opacity: 0;
}
.ml-15 {
  margin-left: 6vw;
}
</style>
